<template>
  <v-card v-if="editObject" v-click-outside="unfocusEntireCard">
    <slotted-card :editable="true" :title="$t('servicesystem.common_objects.customer.conditions')" :icon="''"
      :fontsize="'h3'" :externalEditTrigger="edittrigger" @editMode="m => { editMode = m }" @valid="v => { valid = v }">
      <template v-slot:content>
        <v-container fluid class="pa-0">
          <v-row v-for="field in conditionFields" :key="field.key" no-gutters class="px-3 pt-1">
            <v-col>
              <v-skeleton-loader v-if="!initiated" type="list-item">
              </v-skeleton-loader>
              <QTextArea v-else v-model="editObject[field.key]" :label="field.label" :externaledit="editMode"
                :loading="isLoading" @FocusState="editMode ? null : edittrigger++">
              </QTextArea>
            </v-col>
          </v-row>
        </v-container>
        <edit-bar v-if="editMode" :externalTrigger="editMode" :saveable="valid && IsChanged" @saveEmit="handleSave"
          @modeEmit="edittrigger++">
        </edit-bar>
      </template>
    </slotted-card>
  </v-card>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin";
import EditBar from "@/components/Sections/Editbar.vue";
import SlottedCard from "@/views/layouts/SlottedCardSection.vue";

export default {
  name: "CustomerConditionsCard",
  props: {
    customerId: String,
  },
  components: {
    EditBar,
    SlottedCard,
  },
  mixins: [clientAPI],

  data() {
    return {
      initiated: false,
      isLoading: false,
      conditionFields: [
        { key: 'Condition1', label: this.$t('servicesystem.common_objects.customer.condition1') },
        { key: 'Condition2', label: this.$t('servicesystem.common_objects.customer.condition2') },
        { key: 'Condition3', label: this.$t('servicesystem.common_objects.customer.condition3') },
        { key: 'Condition4', label: this.$t('servicesystem.common_objects.customer.condition4') },
        { key: 'Condition5', label: this.$t('servicesystem.common_objects.customer.condition5') },
        { key: 'Condition6', label: this.$t('servicesystem.common_objects.customer.condition6') },
      ],
      valid: false,
      editMode: false,
      edittrigger: 1,
      editObject: {},
    };
  },

  mounted() {
    this.fetch();
  },

  methods: {
    fetch() {
      if (this.customerId) {
        this.isLoading = true;
        clientAPI.methods.getCustomerConditionsById(this.customerId)
          .then(response => {
            this.editObject = Object.assign({}, response);
            this.copyObject = Object.assign({}, response);
          })
          .finally(() => {
            this.isLoading = false;
            this.initiated = true;
          });
      }
      else {
        this.editObject = {};
        this.copyObject = {};
      }
    },

    handleSave() {
      const dto = Object.assign({}, this.editObject);
      //console.log("Sending change", dto);
      this.setCustomerConditionsById(dto)
        .then((response) => {
          this.editObject = Object.assign({}, response);
          this.copyObject = Object.assign({}, response);
          this.edittrigger++;
        })
        .catch((exception) => {
          console.error(exception);
        });
    },

    unfocusEntireCard() {
      if (!this.IsChanged && this.editMode) {
        this.edittrigger++;
      }
    },
  },

  computed: {
    IsChanged() {
      if (this.editObject && this.copyObject) {
        return !this.SameValue(this.editObject, this.copyObject);
      } else {
        return false;
      }
    },
  },

  watch: {
    customerId: function () {
      this.fetch();
    },
  },
};
</script>


<style lang='scss' scoped></style>